<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "student",
  data() {
    return {};
  },
  created() {}
};
</script>
